import { Link } from "react-router-dom";

import { SwiftLogo } from "@/components/brand/swift-logo";
import { ThemeToggle } from "@/components/theme/theme-toggle";
import { buttonVariants } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";

export function Header() {
  const { session, status } = useAuth();

  return (
    <header className="sticky top-0 z-30 w-full border-b border-border bg-background/80 backdrop-blur-md supports-[backdrop-filter]:bg-background/60">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-6">
        <Link
          to="/"
          aria-label="Swift MVP - home"
          className="brand-focus-ring inline-flex items-center rounded-md"
        >
          <SwiftLogo priority className="h-7 w-auto sm:h-8 dark:invert" />
        </Link>
        <nav className="flex items-center gap-2">
          <ThemeToggle className="hidden sm:inline-flex" />
          {status === "loading" ? null : session ? (
            <Link
              to="/dashboard"
              className={cn(buttonVariants({ variant: "default", size: "sm" }), "no-underline")}
            >
              Dashboard
            </Link>
          ) : (
            <>
              <Link
                to="/signin"
                className={cn(
                  buttonVariants({ variant: "ghost", size: "sm" }),
                  "no-underline",
                )}
              >
                Sign in
              </Link>
              <Link
                to="/signin"
                className={cn(buttonVariants({ variant: "default", size: "sm" }), "no-underline")}
              >
                Get started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
